import React from "react";
import Page, { PageProps } from "../Page";
import PasswordChangeForm from "./PasswordChangeForm";
import Text from "antd/lib/typography/Text";
import { IChangePasswordPresenter } from "../../../presenter/authentication/ChangePasswordPresenter";
import PasswordResetForm from "./PasswordResetForm";

export interface Props extends PageProps {}
export interface State extends IChangePasswordPresenter {}

export default class ForgottenPasswordPage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    let {
      translate,
      username,
      application,
      setUsername,
      resetPassword,
      buttonDisabled
    } = this.state;

    return (
      <Page
        {...this.props}
        style={{
          display: "flex",
          justifyContent: "center",
          height: "100%",
          width: "100%",
          flexDirection: "column",
          alignItems: "center"
        }}
      >
        <PasswordResetForm
          router={this.props.router}
          translate={translate}
          username={username}
          resetPassword={resetPassword}
          buttonDisabled={buttonDisabled}
          onChangeUsername={setUsername}
          loading={this.state.loaders.loginLoader}
          title={application.applicationName}
        />
      </Page>
    );
  }
}
